import { EPhysicalType } from '@web/entities/point/model/physical-type.enum'
import type { IOption } from '@web/shared/types/options.type'

export const mapPhysicalQuantityType: Record<EPhysicalType, string> = {
  [EPhysicalType.VIBRO_ACCELERATION]: 'Виброускорение',
  [EPhysicalType.TEMPERATURE]: 'Температура',
  [EPhysicalType.RPM]: 'Частота вращения',
  [EPhysicalType.AMPERAGE]: 'Сила тока',
  [EPhysicalType.DRPM]: 'Изменение частоты вращения',
  [EPhysicalType.VOLTAGE]: 'Напряжение',
  [EPhysicalType.VIBRO_VELOCITY]: 'Виброскорость',
  [EPhysicalType.PHASE]: 'Фаза',
  [EPhysicalType.VIBRO_DISPLACEMENT]: 'Виброперемещение',
  [EPhysicalType.PRESSURE]: 'Давление',
  [EPhysicalType.FLOW_RATE]: 'Расход'
}

export const typesPointOptions: Array<IOption<EPhysicalType>> = [
  {
    label: mapPhysicalQuantityType[EPhysicalType.VIBRO_ACCELERATION],
    value: EPhysicalType.VIBRO_ACCELERATION
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.VIBRO_VELOCITY],
    value: EPhysicalType.VIBRO_VELOCITY
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.VIBRO_DISPLACEMENT],
    value: EPhysicalType.VIBRO_DISPLACEMENT
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.TEMPERATURE],
    value: EPhysicalType.TEMPERATURE
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.VOLTAGE],
    value: EPhysicalType.VOLTAGE
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.AMPERAGE],
    value: EPhysicalType.AMPERAGE
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.PHASE],
    value: EPhysicalType.PHASE,
    disabled: true
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.RPM],
    value: EPhysicalType.RPM
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.DRPM],
    value: EPhysicalType.DRPM,
    disabled: true
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.PRESSURE],
    value: EPhysicalType.PRESSURE,
    disabled: true
  },
  {
    label: mapPhysicalQuantityType[EPhysicalType.FLOW_RATE],
    value: EPhysicalType.FLOW_RATE,
    disabled: true
  }
]
